import { Route } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';
import { NotAuthGuard } from '../guards/notAuth.guard';
import { RoleGuard } from '../guards/role.guard';
import { donationRoutes } from './donations.routes';
import { donorsRoutes } from './donors.routes';
import { managersRoutes } from './managers.routes';
import { reportsRoutes } from './reports.routes';
import { usersRoutes } from './users.routes';

export const routes: Route[] = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'login',
    pathMatch: 'full',
    loadComponent: () =>
      import('../../auth/pages/auth-frame/auth-frame.component').then(
        (mod) => mod.AuthFrameComponent
      ),
    data: { current: 'login' },
    canActivate: [NotAuthGuard],
  },
  {
    path: 'home',
    loadComponent: () =>
      import('../../home/home.component').then((mod) => mod.HomeComponent),
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: 'cart-configuration',
    loadComponent: () =>
      import('../../features/settings/pages/cart-config/cart-config').then(
        (mod) => mod.CartConfig
      ),
    pathMatch: 'full',
    canActivate: [AuthGuard, RoleGuard],
    data: {
      allowedRoles: ['superAdmin', 'supervisor'],
    },
  },
  {
    path: 'charity-organizations',
    loadComponent: () =>
      import(
        '../../features/settings/pages/charity-organizations/charity-organizations'
      ).then((mod) => mod.CharityOrganizations),
    pathMatch: 'full',
    canActivate: [AuthGuard, RoleGuard],
    data: {
      allowedRoles: ['superAdmin', 'supervisor'],
    },
  },
  ...usersRoutes,
  ...donationRoutes,
  ...donorsRoutes,
  ...managersRoutes,
  ...reportsRoutes,
  { path: '**', redirectTo: 'home' },
];
